import { apiCall } from './gqlClient';

const RECIPES_QUERY = `
  query recipes($providerId: Float!) {
    recipes(providerId: $providerId)
    {
      id
			providerId
			name
			description
			category
			servings
			servingWeightG
			weightEstimated
			instructions
			isPublic
			isTemplate
			imageId
			imageUrl
			tags
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			sodiumMg
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const recipesApiCall = async ({providerId}, fragments = null) => apiCall({ query: RECIPES_QUERY, variables: {providerId}, fragments });

const RECIPE_QUERY = `
  query recipe($id: String!) {
    recipe(id: $id)
    {
      id
			providerId
			name
			description
			category
			servings
			servingWeightG
			weightEstimated
			instructions
			isPublic
			isTemplate
			imageId
			imageUrl
			tags
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			sodiumMg
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const recipeApiCall = async ({id}, fragments = null) => apiCall({ query: RECIPE_QUERY, variables: {id}, fragments });

const RECIPEINGREDIENTS_QUERY = `
  query recipeIngredients($recipeId: String!) {
    recipeIngredients(recipeId: $recipeId)
    {
      id
			recipeId
			ingredientId
			quantityG
			stepOrder
			note
      ...fragments
    }
  }`;

export const recipeIngredientsApiCall = async ({recipeId}, fragments = null) => apiCall({ query: RECIPEINGREDIENTS_QUERY, variables: {recipeId}, fragments });

const CREATERECIPE_QUERY = `
  mutation createRecipe($input: RecipeInput!) {
    createRecipe(input: $input)
    {
      id
			providerId
			name
			description
			category
			servings
			servingWeightG
			weightEstimated
			instructions
			isPublic
			isTemplate
			imageId
			imageUrl
			tags
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			sodiumMg
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const createRecipeApiCall = async ({input}, fragments = null) => apiCall({ query: CREATERECIPE_QUERY, variables: {input}, fragments });

const UPDATERECIPE_QUERY = `
  mutation updateRecipe($id: String!, $input: RecipeInput!) {
    updateRecipe(id: $id, input: $input)
    {
      id
			providerId
			name
			description
			category
			servings
			servingWeightG
			weightEstimated
			instructions
			isPublic
			isTemplate
			imageId
			imageUrl
			tags
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			sodiumMg
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const updateRecipeApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATERECIPE_QUERY, variables: {id, input}, fragments });

const DELETERECIPE_QUERY = `
  mutation deleteRecipe($id: String!) {
    deleteRecipe(id: $id)
    {
      id
			providerId
			name
			description
			category
			servings
			servingWeightG
			weightEstimated
			instructions
			isPublic
			isTemplate
			imageId
			imageUrl
			tags
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
			sugarG
			sodiumMg
			isVegan
			isVegetarian
			isGlutenFree
			isLactoseFree
			isLowFodmap
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const deleteRecipeApiCall = async ({id}, fragments = null) => apiCall({ query: DELETERECIPE_QUERY, variables: {id}, fragments });

const CREATERECIPEINGREDIENT_QUERY = `
  mutation createRecipeIngredient($input: RecipeIngredientInput!) {
    createRecipeIngredient(input: $input)
    {
      id
			recipeId
			ingredientId
			quantityG
			stepOrder
			note
      ...fragments
    }
  }`;

export const createRecipeIngredientApiCall = async ({input}, fragments = null) => apiCall({ query: CREATERECIPEINGREDIENT_QUERY, variables: {input}, fragments });

const DELETERECIPEINGREDIENT_QUERY = `
  mutation deleteRecipeIngredient($id: String!) {
    deleteRecipeIngredient(id: $id)
    {
      id
			recipeId
			ingredientId
			quantityG
			stepOrder
			note
      ...fragments
    }
  }`;

export const deleteRecipeIngredientApiCall = async ({id}, fragments = null) => apiCall({ query: DELETERECIPEINGREDIENT_QUERY, variables: {id}, fragments });
